module.exports = __webpack_public_path__ + "static/media/icon-payment-approved.fff28294.svg";